import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { repertoire } from '../data/repertoire';
import { PageIntro } from '../components/ui/PageIntro';
import { RepertoireBrowser } from '../components/repertoire/RepertoireBrowser';
import { CtaBand } from '../components/ui/CtaBand';
const total = repertoire.reduce((n, e) => n + e.songs.length, 0);
export function Repertoire() {
  usePageTitle('Repertoire');
  const [params] = useSearchParams();
  return <>
      <PageIntro eyebrow="Repertoire" title={<>
            {total} nummers, <em className="text-amber" data-id="element-444" data-mp="1wl7cxb0wehph">van Hazes tot Hotel California.</em>
          </>} intro="Nederlandstalige meezingers, internationale klassiekers en alles voor kerst en feestdagen. Zoek op artiest of titel — en mist u een nummer, vraag het gerust aan." data-id="element-443" data-mp="2ac44cyj38suy" />
      <section aria-label="Volledig repertoire" className="w-full bg-ink" data-id="element-445" data-mp="1rl2uvgkcdex5">
        <div className="mx-auto max-w-7xl px-5 pb-24 md:px-10 lg:pb-32" data-id="element-446" data-mp="1gzg70iz29r1j">
          <RepertoireBrowser initialQuery={params.get('q') ?? ''} data-id="element-447" data-mp="1h1j4fo2jmmga" />
        </div>
      </section>
      <CtaBand title="Een verzoeknummer?" text="Staat uw favoriet er niet tussen? Veel nummers studeer ik graag speciaal voor uw gelegenheid in." to="/contact?type=optreden" label="Vraag een nummer aan" data-id="element-448" data-mp="1c2fxfy30665o" />
    </>;
}